import { atom } from 'jotai';

export const model1State = atom(null);
export const model2State = atom(null);